/**
 * Class names for Delimiter
 */
// eslint-disable-next-line etc/no-const-enum
export var DelimiterClasses;
(function (DelimiterClasses) {
    /**
     * Class name to specify this delimiter is before an entity
     */
    DelimiterClasses["DELIMITER_BEFORE"] = "entityDelimiterBefore";
    /**
     *  Class name to specify this delimiter is after an entity
     */
    DelimiterClasses["DELIMITER_AFTER"] = "entityDelimiterAfter";
})(DelimiterClasses || (DelimiterClasses = {}));
//# sourceMappingURL=DelimiterClasses.js.map